/**
 * Browsers built into chat/social apps (Zalo, Messenger, Instagram…). Google refuses to sign in
 * there (`disallowed_useragent`), so the app asks the runner to open the page in Safari/Chrome.
 */
const IN_APP =
  /\b(Zalo|FBAN|FBAV|FB_IAB|FBIOS|Instagram|Line\/|MicroMessenger|TikTok|BytedanceWebview|Musical_ly)\b/i;

export function isInAppBrowser(
  ua: string = typeof navigator === 'undefined' ? '' : navigator.userAgent,
): boolean {
  return IN_APP.test(ua);
}
